// apps/nos/client/src/hooks/useReferenceTargetCatalog.ts
import { useQuery } from "@tanstack/react-query";
import { fetchReferenceTargetCatalog } from "@/services/flavor_api";

export function useReferenceTargetCatalog() {
  return useQuery({
    queryKey: ["flavor", "reference-target-catalog"],
    queryFn: fetchReferenceTargetCatalog,
    staleTime: 5 * 60_000,
  });
}
